// Same rule as the operator dashboard's safeHttpUrl: the value is stored as
// typed and rendered inside an href, so only absolute http(s) URLs pass.
// Returns the trimmed URL, or "" for anything else (including blank).
export const safeHttpUrl = (value: unknown): string => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === "http:" || parsed.protocol === "https:"
      ? trimmed
      : "";
  } catch (e) {
    return "";
  }
};
